import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20gradient%20background%20with%20soft%20tomato%20red%20and%20deep%20crimson%20tones%2C%20abstract%20flowing%20shapes%20and%20geometric%20patterns%2C%20modern%20streaming%20platform%20atmosphere%2C%20dark%20elegant%20background%20with%20subtle%20texture%2C%20premium%20entertainment%20brand%20visual&width=1920&height=800&seq=hero-bg-tomato-01&orientation=landscape"
          alt="番茄视频背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-[900px] mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-heading leading-tight">
          发现你的<span className="text-primary-400">下一个</span>精彩视频
        </h1>
        <p className="text-sm md:text-base text-background-200 mb-8 max-w-[600px] mx-auto leading-relaxed">
          番茄视频聚合妖精视频、桃花视频、苹果视频、榴莲视频等特色内容，<br className="hidden sm:block" />
          动漫、短视频、搞笑视频、趣味节目一应俱全，高清画质免费在线观看
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dongman"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            立即探索
          </Link>
          <Link
            to="/category/tesejiemu"
            className="px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            特色节目
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white font-heading">8,500+</div>
            <div className="text-xs text-background-300 mt-1">优质视频</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">1200万+</div>
            <div className="text-xs text-background-300 mt-1">日播放量</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white font-heading">360万+</div>
            <div className="text-xs text-background-300 mt-1">活跃用户</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">15+</div>
            <div className="text-xs text-background-300 mt-1">内容分类</div>
          </div>
        </div>
      </div>
    </section>
  );
}